import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  item: {
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'flex-start',
    },
  },
  details: {
    display: 'inline-grid',
    gridTemplateColumns: (props) =>
      props?.hasCheckinTime ? 'max-content max-content' : 'max-content max-content max-content',
    gridAutoRows: 'auto',
    gap: '24px',
    rowGap: '12px',
    justifyContent: 'center',
    flexWrap: 'wrap',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
  },
  checkinTimeLabel: {
    width: '150px',
    flexShrink: 0,
  },
  checkinTimeValue: {
    flexGrow: 1,
  },
}));

export default useStyles;
